// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import messageChatCircleIcon from "@/assets/icons/message-chat-circle.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type MessageChatCircleIconProps = Omit<IconProps, "name">;

export function MessageChatCircleIcon(props: MessageChatCircleIconProps): React.ReactNode {
  return <Icon name={messageChatCircleIcon} {...props} />;
}
